import React from "react";

const TermsOfService = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-4">Last updated: April 10, 2025</p>

      <p className="mb-4">
        Welcome to Plog Social. By accessing our website, you agree to these
        terms and conditions.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Acceptance of Terms
      </h2>
      <p className="mb-4">
        By accessing and using Plog Social ("the Service"), you accept and agree
        to be bound by the terms and provision of this agreement.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Use License</h2>
      <p className="mb-4">
        Permission is granted to temporarily access the materials on Plog
        Social's website for personal, non-commercial transitory viewing only.
      </p>
      <p className="mb-4">
        This license shall automatically terminate if you violate any of these
        restrictions and may be terminated by Plog Social at any time.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. User Content</h2>
      <p className="mb-4">
        Users may post content to the Service. You retain ownership of your
        content, but grant us a license to use, modify, and distribute it.
      </p>
      <p className="mb-4">
        You are responsible for ensuring your content does not violate any laws
        or infringe on others' rights.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Advertising</h2>
      <p className="mb-4">
        Our website uses Google AdSense to display advertisements. By using our
        service, you acknowledge that:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Advertisements may be displayed on our website</li>
        <li>Google may use cookies to serve ads based on your visits</li>
        <li>
          You can opt out of personalized advertising through Google's settings
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Privacy</h2>
      <p className="mb-4">
        Your privacy is important to us. Please review our Privacy Policy, which
        also governs your use of the Service.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Disclaimer</h2>
      <p className="mb-4">
        The materials on Plog Social's website are provided on an 'as is' basis.
        Plog Social makes no warranties, expressed or implied, and hereby
        disclaims and negates all other warranties including without limitation,
        implied warranties or conditions of merchantability, fitness for a
        particular purpose, or non-infringement of intellectual property or
        other violation of rights.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Limitations</h2>
      <p className="mb-4">
        In no event shall Plog Social or its suppliers be liable for any damages
        (including, without limitation, damages for loss of data or profit, or
        due to business interruption) arising out of the use or inability to use
        the materials on Plog Social's website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Revisions and Errata
      </h2>
      <p className="mb-4">
        The materials appearing on Plog Social's website could include
        technical, typographical, or photographic errors. Plog Social does not
        warrant that any of the materials on its website are accurate, complete
        or current.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Links</h2>
      <p className="mb-4">
        Plog Social has not reviewed all of the sites linked to its website and
        is not responsible for the contents of any such linked site. The
        inclusion of any link does not imply endorsement by Plog Social of the
        site.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Modifications</h2>
      <p className="mb-4">
        Plog Social may revise these terms of service for its website at any
        time without notice. By using this website you are agreeing to be bound
        by the then current version of these Terms and Conditions of Use.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        11. Contact Information
      </h2>
      <p className="mb-4">
        If you have any questions about these Terms of Service, please contact
        us at <strong>QuintyneRealty@hotmail.com</strong>.
      </p>

      <p className="mt-8 text-sm text-gray-600">
        These terms of service are effective as of April 10, 2025.
      </p>
    </div>
  );
};

export default TermsOfService;
